// src/theme/radii.js
// Modern ve AI temasına uygun köşe yuvarlaklıkları
const radii = {
  none: '0',
  sm: '0.25rem',    // 4px
  base: '0.375rem', // 6px (Chakra'nın md'si)
  md: '0.5rem',     // 8px (Yeni md)
  lg: '0.75rem',    // 12px
  xl: '1rem',       // 16px
  '2xl': '1.5rem',  // 24px
  '3xl': '2rem',    // 32px
  full: '9999px',   // Tamamen yuvarlak
};

export default radii;
